import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SITE } from '../data/site';
import './Header.css';

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
      <div className="nav__inner shell">
        <Link to="/" className="nav__brand" aria-label={`${SITE.name} home`}>
          <span className="nav__wordmark">ARCADIA&rsquo;84</span>
        </Link>

        <button
          type="button"
          className="nav__toggle"
          aria-expanded={open}
          aria-label="Toggle navigation"
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`nav__links${open ? ' nav__links--open' : ''}`} onClick={() => setOpen(false)}>
          <NavLink to="/#games" className="nav__link">
            GAMES
          </NavLink>
          <NavLink to="/#passes" className="nav__link">
            PASSES
          </NavLink>
          <NavLink to="/about" className="nav__link">
            ABOUT
          </NavLink>
          <NavLink to="/contact" className="nav__link">
            CONTACT
          </NavLink>
          <a className="btn nav__cta" href={SITE.appUrl}>
            PLAY FREE &#9656;
          </a>
        </nav>
      </div>
    </header>
  );
}
